import { TextField } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { TextAnswerSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/textAnswerModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: TextAnswerSubtypeDataModel;
}

export default function TextAnswerSubtypeDetails(props: Props) {
    return <>
        <TextField
            value={props.subtypeData.textAnswer}
            onChange={() => { }}
            multiline
            fullWidth />
    </>
}
